import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Center Details',
    label: 'ข้อมูลศูนย์ทดสอบ',
    path: '/admin/exam-centers/:examCenterCode/details',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW],
  },
  {
    value: 'Exam Center Details Members',
    label: 'สมาชิก',
    path: '/admin/exam-centers/:examCenterCode/details/members',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.VIEW],
  },
  {
    value: 'Exam Center Details Exam Courses',
    label: 'หลักสูตรที่เปิดสอบ',
    path: '/admin/exam-centers/:examCenterCode/details/exam-courses',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW],
  },
];

export default function ExamCenterDetailsNavigationTabs() {
  const { permissions } = usePermission();

  const tabItems = useMemo(
    () =>
      TAB_ITEMS.filter(({ requiredPermission }) => {
        return (
          !requiredPermission?.length ||
          requiredPermission.every((permission) => permissions.includes(permission))
        );
      }),
    [permissions],
  );

  return <NavigationTabs items={tabItems} />;
}
